<template>
    <!-- <app-layout> -->


    <div class="flex flex-grow flex-col -ml-4 sm:-ml-6 lg:-ml-8 -mr-4 sm:-mr-6 lg:-mr-8 w-full">

        <div class="flex flex-col md:flex-row w-full flex-grow relative max-w-full">

            <splitpanes class="default-theme video" v-bind:class="{ 'fixed': is_visitor }" @resized="paneResize"
                @resize="paneResize">

                <pane min-size="30" :size="main_size">
                    <div
                        :class="[video_full_width ? 'justify-start pt-3 pl-3' : 'justify-center pt-8', 'flex flex-grow h-full flex-col items-center relative']">

                        <video-share :video="video" :the_team_slug="team_slug" :is_godview="false"
                            :is_visitor="is_visitor" :team_admins="team_admins" :team_owner_email="team_owner_email"
                            :teamtags="teamtags" :plan_secure_sharing="plan_secure_sharing" :datacenter="datacenter"
                            :video_loaded="video_loaded" :video_error="video_error" :pane_size="pane_size"
                            :transcoding_error="transcoding_error" :video_full_width="video_full_width" :way="way"
                            :folders="folders" :otherFolders="otherFolders" :video_gif="video_gif"
                            :video_thumb="video_thumb"></video-share>


                        <a href="#"
                            class="flex w-8 h-10 absolute right-0 cursor-pointer items-center justify-center hover:opacity-70 top-7"
                            @click.prevent.stop="expandSidebar" v-if="!reopen && !is_visitor && !resized && !panel_open"
                            v-tippy="{ content: 'Expand Tools', placement: 'bottom', arrow: false }">
                            <vue-feather type="chevrons-left" class="h-6 w-6"></vue-feather>
                        </a>

                    </div>



                </pane>

                <!--                     <div class="flex w-1 bg-blue-500 cursor-ew-resize" style="cursor:ew-resize"></div> -->
                <pane min-size="30" v-if="panel_open" :size="panel_size">

                    <div v-if="is_visitor"
                        class="flex flex-grow h-full bg-gray-800 border-l-0 border-gray-300 flex-col justify-start pt-5 md:pt-12 px-4 mt-10 md:mt-0 text-white text-sm">
                        <div class="pt-5 px-4">
                            More details for members<br />of <span class="font-bold">{{ team_name }}</span> team.
                        </div>
                        <div class="pt-5 px-4">
                            <a :href="route('hello', { redirect: '/library/' + video.uuid, sidebar: 'open' })"
                                title="Sign in"
                                class="mt-3 inline-flex items-center px-4 py-2 bg-transparent border-2 border-gray-600 rounded-md text-sm text-white uppercase hover:bg-gray-600 hover:border-transparent focus:outline-none transition">
                                Sign in
                            </a>
                        </div>
                    </div>

                    <share-sidebar v-else :video="video" :team_owner_email="team_owner_email" :team_name="team_name"
                        :share_original="share_original" :meta="meta" :consolelogs="consolelogs"
                        :networklogs="networklogs" :has_installed_snippet="has_installed_snippet"
                        :plan_transcribing="plan_transcribing" :plan_console="plan_console"
                        :transcribing_enabled="transcribing_enabled" :transcribing_enabled_sent="transcribing_enabled_sent" :transcribing="transcribing"
                        :is_extension="is_extension" :video_loaded="video_loaded" :console_loaded="console_loaded"
                        :network_loaded="network_loaded">
                    </share-sidebar>

                </pane>

            </splitpanes>

            <span v-if="!is_visitor && panel_open && false" class="absolute top-6 w-4 h-8 right-12 flex items-center justify-center">
                <InformationCircleIcon class="h-4 w-4 text-gray-400"
                    v-tippy="{ content: 'This toolbar is only visible to your team', placement: 'bottom', arrow: false }" />
            </span>

            <a href="#"
                class="flex w-8 h-8 absolute right-2 cursor-pointer items-center justify-center hover:opacity-70 text-sm top-2 xl:top-6"
                @click.prevent.stop="toggleSidebar"
                v-tippy="{ content: panel_open ? 'Hide Toolbar' : 'Show Toolbar', placement: 'bottom', arrow: false }">
                <ChevronDoubleLeftIcon v-if="!panel_open" class="h-6 w-6"></ChevronDoubleLeftIcon>
                <XMarkIcon v-else class="h-6 w-6 text-white"></XMarkIcon>
            </a>

        </div>


        <div class="relative w-full bg-blue-500 text-white text-center py-6" v-if="is_visitor && footer_view">
            <a href="#" @click.prevent.stop="footer_view = false"
                class="absolute top-3 right-4 h-4 w-4 hover:text-blue-800" title="Close">
                <vue-feather type="x" class="h-4 w-4"></vue-feather>
            </a>

            <h5 class="text-2xl font-semibold">Secure screen recording for modern Support teams and their customers.
            </h5>
            <p class="text-lg font-medium">Speed up resolution and provide an outstanding experience.</p>
            <p class="mt-3">
                <a :href="'https://www.' + domain" taget="_blank" :title="'Add ' + app_name + ' to your helpdesk'"
                    class="mt-3 inline-flex items-center px-4 py-2 bg-white border-2 border-transparent rounded-md font-bold text-sm text-blue-500 uppercase tracking-widest hover:bg-blue-500 hover:text-white hover:border-white active:bg-blue-500 focus:outline-none focus:border-white focus:ring focus:ring-white disabled:opacity-25 transition">
                    Add {{ app_name }} to your helpdesk
                </a>
            </p>
        </div>

    </div>

    <!-- </app-layout> -->
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import VideoList from '@/Components/Video/VideoList'
import ShareSidebar from '@/Components/Sidebar/HomeSidebar'
import VideoShare from '@/Components/Video/VideoShare'
import { XMarkIcon, ChevronDoubleLeftIcon } from "@heroicons/vue/20/solid";
import { InformationCircleIcon } from "@heroicons/vue/24/outline";

import { Splitpanes, Pane } from 'splitpanes'
//import 'splitpanes/dist/splitpanes.css'

export default {
    props: [
        'created_at_readable', // only for auth
        'created_at_readable_local', // only for auth

        'teamtags', // for both but always empty array [] for visitors
        'meta', // for both but always empty string "" for visitors
        'team_owner_email', // for both...
        'title',
        'the_video',
        'team_name',
        'team_slug',
        //'contact_name',
        //'contact_email',
        'is_visitor',
        'team_admins',
        'share_original', // only for visitors
        'the_consolelogs',
        'the_networklogs',
        'has_installed_snippet',
        'sidebar_open_at_start',
        'datacenter',
        'plan_transcribing',
        'plan_console',
        'plan_secure_sharing',
        'transcribing_enabled',
        'transcribing_enabled_sent',
        'transcribing',
        'is_extension',
        'way', 'folders', 'otherFolders'
    ],
    layout: AppLayout,
    components: {
        AppLayout,
        VideoList,
        ShareSidebar,
        VideoShare,
        Splitpanes, Pane,
        XMarkIcon, ChevronDoubleLeftIcon,
        InformationCircleIcon
    },
    data() {
        return {
            video: this.the_video,
            consolelogs: this.the_consolelogs,
            networklogs: this.the_networklogs,
            current_location: window.location,
            footer_view: false,
            panel_open: !this.is_visitor, //this.sidebar_open_at_start,
            reopen: false,
            resized: false,
            domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
            app_name: this.$page.props.app_name,
            video_loaded: true,
            console_loaded: true,
            network_loaded: true,
            retries_count: 0,
            video_error: false,
            transcoding_error: false,
            video_metadata: null,
            refresh: 1,
            pane_size: 70,
            video_gif: null,
            video_thumb: null,
        }
    },
    created() {
        let should_reload = false;
        if (!this.video.video_file) {
            should_reload = true;
            this.video_loaded = false;
        }
        if (this.video.image_gif) {
            this.video_gif = this.video.image_gif;
        }
        if (this.video.image_thumb) {
            this.video_thumb = this.video.image_thumb;
        }

        if (this.video.metadata) {
            this.video_metadata = JSON.parse(this.video.metadata);
            if (this.video_metadata) {
                if (this.video_metadata.has_console_logs && this.consolelogs.length == 0) {
                    should_reload = true;
                    this.console_loaded = false;
                }
                if (this.video_metadata.has_network_logs && this.networklogs.length == 0) {
                    should_reload = true;
                    this.network_loaded = false;
                }
            }
        }
        if (should_reload) {
            setTimeout(function () {
                this.reload_video();
            }.bind(this), 1000);
        }
    },
    beforeUnmount() {
        // this.EventBus.off("start.call", this.test);
    },
    mounted() {
        // this.EventBus.emit("start.call", "hello")
    },
    methods: {
        toggleSidebar() {
            this.panel_open = !this.panel_open
            this.reopen = true
            this.pane_size = this.panel_open ? 50 : 100
        },
        expandSidebar() {
            this.reopen = true
            this.pane_size = 50
        },
        paneResize(data) {
            this.resized = true
            if (data.length == 2) {
                this.pane_size = data[0].size
            }
        },
        refresh_fetched_data(data) {
            if (data.video) {
                if (!this.video_loaded && !data.video.video_file) {
                    this.video_loaded = false;
                }
                if (data.video.image_gif) {
                    this.video_gif = data.video.image_gif;
                }
                if (data.video.image_thumb) {
                    this.video_thumb = data.video.image_thumb;
                }
                if (data.video.video_file) {
                    this.video = data.video;
                    this.video_loaded = true;
                }
            }
            if (data.consolelogs && !this.console_loaded) {
                this.consolelogs = data.consolelogs;
                this.console_loaded = true;
                this.refresh++
            }
            if (data.networklogs && !this.network_loaded) {
                this.networklogs = data.networklogs;
                this.network_loaded = true;
                this.refresh++
            }

            if (data.metadata && this.video_metadata) {
                this.video_metadata = JSON.parse(data.metadata);
                if (this.video_metadata.transcoding) {
                    if (this.video_metadata.transcoding == "error") {
                        this.transcoding_error = true;
                        return;
                    }
                }
            }

            let need_reload = false;
            if (!this.is_visitor && this.video_metadata) {
                if (this.video_metadata.has_console_logs && !this.console_loaded) {
                    need_reload = true;
                }
                if (this.video_metadata.has_network_logs && !this.network_loaded) {
                    need_reload = true;
                }
            }
            if (!this.video.video_file) {
                need_reload = true;
            }

            if (need_reload) {
                setTimeout(function () {
                    this.reload_video();
                }.bind(this), 1000);
            } else {
                this.video_loaded = true;
                this.console_loaded = true;
                this.network_loaded = true;
            }
        },

        reload_video: function () {

            let url = this.$page.props.api_url + '/v1/video_details/' + this.video.uuid;

            // if (!this.is_visitor) {
            //    url = this.$page.props.api_url + '/v1/video/' + this.video.uuid + '/logs/';
            let params = [];
            if (!this.is_visitor && this.video_metadata) {
                if (this.video_metadata.has_console_logs && !this.console_loaded) {
                    params.push('consolelogs=true');
                }
                if (this.video_metadata.has_network_logs && !this.network_loaded) {
                    params.push('networklogs=true');
                }
            }
            if (!this.video_loaded) {
                params.push('videofile=true');
            }
            if (params.length > 0) {
                url += '?' + params.join('&');
            }
            // }

            axios.get(url)
                .then(response => {
                    this.refresh_fetched_data(response.data);
                })
                .catch(e => {
                    console.error(e);
                    this.retries_count += 1
                    if (this.retries_count < 300) { // rety 300x every 2 seconds makes 10 minutes waiting
                        setTimeout(function () {
                            this.reload_video();
                        }.bind(this), 2000);
                    } else {
                        this.video_error = true;
                    }
                });
        },
    },
    computed: {
        video_full_width() {
            return this.pane_size <= 70 && !this.is_visitor
        },
        panel_size() {
            if (!this.is_visitor && this.reopen) {
                return 50
            }
            return 30
        },
        main_size() {
            if (!this.is_visitor && this.reopen) {
                return 50
            }
            return 70
        },
    }
}
</script>

<style></style>
